import AnalyticsEvent from './AnalyticsEvent';
import UIAnalyticsEvent from './UIAnalyticsEvent';

// Basic events


// UI events


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/analytics-next/dist/esm/types.js
// module id = 5924
// module chunks = 0